import { skipToken, useQuery } from "@tanstack/react-query";
import {
  type IdentityLookupDto,
  getAuthIdentityLookup,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const IDENTITY_LOOKUP_QUERY_KEY = "IDENTITY_LOOKUP";

export const identityLookupKeys = {
  all: [IDENTITY_LOOKUP_QUERY_KEY],
  byLogin: (login?: string | null, companyPartyPublicID?: string | null) => [
    ...identityLookupKeys.all,
    login,
    companyPartyPublicID ?? null,
  ],
};

type Props = {
  login?: string | null;
  companyPartyPublicID?: string | null;
  enabled?: boolean;
};

/**
 * Authenticated lookup answering "does this email already have an Identity in Mo.one and what
 * state is it in?". Used by inviter-side flows (Hunter SendMerchantAccess, future Customer/Merchant
 * invite forms). Rate-limited server-side at 30/min per IP.
 */
export const useIdentityLookupQuery = ({
  login,
  companyPartyPublicID,
  enabled = true,
}: Props) =>
  useQuery<IdentityLookupDto>({
    queryKey: identityLookupKeys.byLogin(login, companyPartyPublicID),
    queryFn: login
      ? processResponseWithApiProblemDetails(() =>
          getAuthIdentityLookup(login, companyPartyPublicID ?? undefined),
        )
      : skipToken,
    enabled,
  });
